export default "__VITE_ASSET__244bbede__"